import axios from 'axios';

import { getLoggedUser, getUserToken } from 'utils';

export const baseService = axios.create({
  baseURL: process.env.REACT_APP_EVALUATION_API_URL,
});

baseService.interceptors.request.use(config => {
  const token = getUserToken();
  const user = getLoggedUser();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (user) {
    config.headers['x-role'] = user?.role;
  }

  return { ...config };
});
